export enum Namespaces {
  impression = "impression"
}
